import { render, staticRenderFns } from "./MaterialSelect.vue?vue&type=template&id=0aea637b&scoped=true"
import script from "./MaterialSelect.vue?vue&type=script&lang=js"
export * from "./MaterialSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aea637b",
  null
  
)

export default component.exports